module.exports = __webpack_public_path__ + "img/submit.f8e5223e.png";